import React from 'react';
import { useLocation } from 'react-router-dom';
import WebhookEventsWrapper from './Components/list/WebhookEventsWrapper';
import CreateEventWrapper from './Components/create/CreateEventWrapper';

const CustomEventModule = () => {
    const location = useLocation();
    const path = location.pathname;

    // Webhook Events page (different UI)
    if (path.includes('/webhook')) {
        return <WebhookEventsWrapper />;
    }

    // Create Event page (Legacy style grid + Form)
    return <CreateEventWrapper />;
};

export default CustomEventModule;
